export default () => ({
  open: false,
  tab: "tab0",
  timer: null,
  session: "open-product-widget",

  init() {
    if (!sessionStorage.getItem(this.session)) {
      this.startTimer();
    }
  },

  startTimer() {
    this.timer = setTimeout(() => this.openWidget(), 3000);
  },

  stopTimer() {
    clearTimeout(this.timer);
  },

  openWidget() {
    this.stopTimer();
    this.tab = "tab0";
    this.open = true;
    sessionStorage.setItem(this.session, `${Date.now()}`);
  },

  closeWidget() {
    this.open = false;
  },
});
